import type { ForjaErrorCode } from '@mxa-argos/modules/forja/interfaces/forja-error-code.interface';

export class ForjaError extends Error {
  constructor(
    readonly code: ForjaErrorCode,
    readonly technicalDetail?: string,
  ) {
    super(technicalDetail ?? code);
    this.name = 'ForjaError';
  }
}

// The code alone names the failure but not what the device answered, which is what a run has to
// be diagnosed from once it is over.
export function toForjaErrorDetail(error: unknown): string {
  if (error instanceof ForjaError) {
    return error.technicalDetail ?? error.code;
  }

  return error instanceof Error ? error.message : String(error);
}

export function toForjaErrorCode(error: unknown): ForjaErrorCode {
  if (error instanceof ForjaError) {
    return error.code;
  }

  console.error('[forja] unexpected error', error);

  return 'UNKNOWN';
}
